module.exports = __webpack_public_path__ + "img/quick_scan.983060e5.png";